import { render, staticRenderFns } from "./IncentivePaymentsTable.vue?vue&type=template&id=3d79afe2"
import script from "./IncentivePaymentsTable.vue?vue&type=script&lang=js"
export * from "./IncentivePaymentsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports